import { Grid, Stack } from "@mui/material";
import { useGetQuotes } from "../../../../services/Quotes.service";
import QuoteCard from "../QuoteCard/QuoteCard";

interface QuoteItem {
  quoteData: any;
  isLoading: boolean;
}

const QuoteContainer = () => {
  const { groupedQuotes } = useGetQuotes();

  return (
    <Grid container>
      <Grid item xs={12} sm={12} sx={{ marginTop: "20px" }}>
        <Stack>
          {Object.keys(groupedQuotes).map((company: string, company_idx: number) => {
            return (groupedQuotes[company] as QuoteItem[]).map(
              (quote: QuoteItem, quote_idx: number) => {
                return (
                  <QuoteCard
                    key={`${company}-${quote_idx}`}
                    quoteData={quote.quoteData}
                    isLoading={quote.isLoading}
                    showMore={
                      quote_idx === 0 && groupedQuotes[company].length > 1
                    }
                    no_of_more_plans={groupedQuotes[company].length - 1}
                    index={quote_idx}
                  />
                );
              }
            );
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default QuoteContainer;